<template>
    <div>
        <label for="nome">Situação</label>
        <b-form-select :options="situacoes" id="situacao" v-model="buscaAvancada.situacao">
            <template #first>
                <b-select-option value="">Todas</b-select-option>
            </template>
        </b-form-select>
    </div>
</template>
<script>
export default {
    props: ['buscaAvancada', 'situacoes']
}
</script>